import { render, staticRenderFns } from "./SystemMessageJoinDate.vue?vue&type=template&id=0d71e843&scoped=true&"
import script from "./SystemMessageJoinDate.vue?vue&type=script&lang=js&"
export * from "./SystemMessageJoinDate.vue?vue&type=script&lang=js&"
import style0 from "./SystemMessageJoinDate.vue?vue&type=style&index=0&id=0d71e843&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d71e843",
  null
  
)

export default component.exports